import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { ChatPill } from '@atlaskit/rovo-agent-components';
import { usePublish } from '@atlaskit/rovo-triggers';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onOpenChatButtonClick } from '../../../ai-answer-dialog/analytics';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../../controller/analytics';
import { ErrorBoundary } from '../error-boundary';
import { messages } from './messages';
export var OpenChatButton = function OpenChatButton(_ref) {
  var prompt = _ref.prompt,
    answerString = _ref.answerString,
    query = _ref.query,
    source = _ref.source,
    experimentCohort = _ref.experimentCohort;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    onClose = _useAIAnswerContext.onClose,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var publish = usePublish('ai-mate');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onOpenChatClick = useCallback(function () {
    fireAnalyticsEvent(onOpenChatButtonClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      experimentCohort: experimentCohort
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.OPEN_CHAT_CLICKED
    });
    // callback is shared with followups
    // used in the issue model view to open up chat in a new tab
    // this is because we don't have access to dismiss the issue view modal
    if (readingAidsOptions !== null && readingAidsOptions !== void 0 && readingAidsOptions.onFollowUpCallback) {
      readingAidsOptions.onFollowUpCallback(prompt);
      return;
    }
    publish({
      type: 'chat-new',
      source: source,
      data: {
        name: query.substring(0, 30),
        dialogues: [{
          human_message: {
            content: prompt
          },
          agent_message: {
            content: answerString
          }
        }],
        sourceId: commonAttributes.searchSessionId
      }
    });
    onClose === null || onClose === void 0 || onClose();
  }, [query, answerString, publish, onClose, commonAttributes, fireAnalyticsEvent, fireSAINUsageEvent, prompt, source, readingAidsOptions, experimentCohort]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(ChatPill, {
    onClick: onOpenChatClick
  }, formatMessage(messages.ai_answer_component_ai_answer_open_chat)));
};